export enum PaymentMethodType {
  CreditCard = "creditCard",
  CembraPay = "cembraPay",
}

export enum PaymentState {
  EPayment = "ePayment",
  Abacus = "abacus"
}
